<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Processo Judicial
            </span>
        </b-button>
		<b-modal
			v-model="showModal"
			id="modalInserirProcesso"
			hide-footer
		>
			<div slot="modal-title">
				Processo Judicial -
				<b-badge variant="warning">Inserir</b-badge>
			</div>
			<processos-judiciais-form
				tipoOperacao="i"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterProcessosAtualizados="$emit('obterProcessosAtualizados')"
				:contrato="contrato"
			></processos-judiciais-form>
		</b-modal>
    </div>
</template>

<script>
import ProcessosJudiciaisForm from './ProcessosJudiciaisForm'

export default {
	components: {
		ProcessosJudiciaisForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
